import { PerformerDetails } from './PerformerDetails';
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PerformerList } from "./PerformerList";
import { PerformerForm } from "./PerformerForm";

export const PerformersPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<PerformerList />} />
      <Route path="/new" element={<PerformerForm />} />
      <Route path="/:id" element={<PerformerDetails />} />
      <Route path="/:id/edit" element={<PerformerForm />} />
      <Route path="*" element={<Navigate to="/performers" replace />} />
    </Routes>
  );
};
